import React, { useState, useEffect, useRef } from 'react';

const F1CustomSelect = ({ value, onChange, options, disabled, placeholder, label }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const selected = options.find(opt => opt.name === value);
        setSelectedOption(selected || null);
    }, [value, options]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);

    const handleSelect = (option) => {
        if (disabled) return;
        onChange(option.name);
        setIsOpen(false);
    };

    return (
        <div className="w-full relative" ref={wrapperRef}>
            {label && <label className="block text-xs text-gray-400 mb-1">{label}</label>}
            <button
                type="button"
                onClick={() => !disabled && setIsOpen(!isOpen)}
                disabled={disabled}
                className={`w-full bg-gray-800 border ${disabled ? 'border-gray-700 opacity-50 cursor-not-allowed' : 'border-gray-600 hover:border-gray-500'} rounded p-2 text-white text-sm flex items-center justify-between transition-colors`}
            >
                <div className="flex items-center gap-3 overflow-hidden">
                    {selectedOption ? (
                        <>
                            {selectedOption.photo ? (
                                <img src={selectedOption.photo} alt={selectedOption.name} className="w-8 h-8 rounded-full object-cover bg-gray-700" />
                            ) : (
                                <div className="w-8 h-8 rounded-full bg-gray-700 flex items-center justify-center text-xs text-gray-400">
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                                </div>
                            )}
                            <div className="flex flex-col items-start truncate">
                                <span className="font-medium truncate">{selectedOption.name}</span>
                                <div className="flex items-center text-xs text-gray-400 truncate">
                                    {selectedOption.teamLogo && <img src={selectedOption.teamLogo} alt={selectedOption.teamName} className="w-4 h-4 object-contain mr-1" />}
                                    <span>{selectedOption.teamName}</span>
                                </div>
                            </div>
                        </>
                    ) : (
                        <span className="text-gray-400 py-1">{placeholder || "Selecione..."}</span>
                    )}
                </div>
                {!disabled && (
                    <svg className={`w-4 h-4 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /></svg>
                )}
            </button>

            {isOpen && !disabled && (
                <div className="absolute z-50 w-full mt-1 bg-gray-800 border border-gray-600 rounded-md shadow-lg max-h-60 overflow-y-auto">
                    <div
                        className="p-2 hover:bg-gray-700 cursor-pointer flex items-center gap-2 text-gray-400 text-sm border-b border-gray-700"
                        onClick={() => handleSelect({ name: '' })}
                    >
                        <span>Limpar seleção</span>
                    </div>
                    {options.map((option) => (
                        <div
                            key={option.id}
                            onClick={() => handleSelect(option)}
                            className={`p-2 hover:bg-gray-700 cursor-pointer flex items-center gap-3 transition-colors ${selectedOption?.id === option.id ? 'bg-gray-700/50' : ''}`}
                        >
                            {option.photo ? (
                                <img src={option.photo} alt={option.name} className="w-10 h-10 rounded-full object-cover bg-gray-600" />
                            ) : (
                                <div className="w-10 h-10 rounded-full bg-gray-600 flex items-center justify-center text-xs text-gray-400">
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                                </div>
                            )}
                            <div className="flex flex-col">
                                <span className="text-white font-medium text-sm">{option.name}</span>
                                <div className="flex items-center text-xs text-gray-400">
                                    {option.teamLogo && <img src={option.teamLogo} alt={option.teamName} className="w-4 h-4 object-contain mr-1" />}
                                    <span>{option.teamName}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default F1CustomSelect;
